function initCalculatorInternal() {
  const calculatorTravelBlock = document.querySelector('._js-calculator-internal-travel');
  if (!calculatorTravelBlock) return;

  localStorage.removeItem('calculator-internal-travel');
  localStorage.removeItem('calculator-temporary-internal-travel');

  const optionsSelectInsurance = calculatorTravelBlock.querySelector('._js-select-insurance-sum')?.getAttribute('data-options');
  const rootStyles = getComputedStyle(document.documentElement);
  const mdBreakpoint = parseInt(rootStyles.getPropertyValue('--md').trim(), 10);
  if (optionsSelectInsurance.length) {
    VirtualSelect.init({
      ele: '._js-select-insurance-sum',
      placeholder: 'Выберите из списка',
      popupDropboxBreakpoint: '300px',
      hideClearButton: true,
      optionHeight: window.innerWidth <= mdBreakpoint ? '42px' : '56px',
      options: JSON.parse(optionsSelectInsurance),
      name: 'insurance-sum'
    });

    document.querySelector('#select-insurance-sum').addEventListener('change', function() {
      activeBtnNext();
      updateTravelTotalSumBlock();
    });
  }

  const optionsSelectAdditional = document.querySelector('._js-select-additional-param')?.getAttribute('data-options');
  if (!optionsSelectAdditional) return;
  VirtualSelect.init({
    ele: '._js-select-additional-param',
    placeholder: 'Выберите из списка',
    popupDropboxBreakpoint: '300px',
    hideClearButton: true,
    optionHeight: window.innerWidth <= mdBreakpoint ? '42px' : '56px',
    options: JSON.parse(optionsSelectAdditional),
  });


  const globalForeign = {};
  const nextStep = calculatorTravelBlock.querySelector('._js-calculator__button-next');
  const backStep = calculatorTravelBlock.querySelector('._js-calculator__button-back');
  const totalBlock = calculatorTravelBlock.querySelector('._js-calculator__block-total-sum');

  let startDate = null;
  let endDate = null;
  const calculatorRangePickerObj = (new CalculatorRangePicker({
    dateFromNode: document.getElementById('startDateTravel'),
    dateToNode: document.getElementById('endDateTravel'),
    dateSelectedEventName: 'calculatorInternalTravel:DateSelected',
  })).init();
  document.addEventListener('calculatorInternalTravel:DateSelected', function(event) {
    let eventStartDate = event?.detail?.startDate;
    let eventEndDate = event?.detail?.endDate;
    startDate = (eventStartDate === false) ? null : (eventStartDate ?? startDate);
    endDate = (eventEndDate === false) ? null : (eventEndDate ?? endDate);
    activeBtnNext();
    updateTravelTotalSumBlock();
  });

  /* Массив путешественников */
  const titleTravels = 'Путешественник';
  const objFormTraveler = localStorage.getItem('calculator-internal-travel') ? JSON.parse(localStorage.getItem('calculator-internal-travel')) : [];
  let objFormTravelerTemporary = {};

  const titleTraveler = calculatorTravelBlock.querySelector('._js-main-foreign-form-title');  // заголовок Путешественник №1

  titleTraveler.innerHTML = `${titleTravels} №${objFormTraveler.length + 1}`;

  const formRadios = calculatorTravelBlock.querySelectorAll('._js-main-foreign-form-radio');
  const countTraveler = calculatorTravelBlock.querySelector('._js-main-foreign-form-input');

  const addTravelerBtn = calculatorTravelBlock.querySelector('._js-main-foreign-add-traveler');
  const saveChangeTravelerBtn = calculatorTravelBlock.querySelector('._js-main-foreign-change-save');
  updateTemporaryTraveler();

  function activeBtnNext() {
    const insurance = document.querySelector('#select-insurance-sum').value;
    const travelers = document.querySelector('._js-main-foreign-list');

    if (startDate && endDate && insurance && ((objFormTraveler.length && travelers.hasChildNodes()) || (Object.keys(objFormTravelerTemporary).length !== 0 && objFormTravelerTemporary.count))) {
      nextStep.classList.remove('_disabled');
    } else {
      nextStep.classList.add('_disabled');
    }
  }

  handleInput(countTraveler, {
    callback: handleTemporaryTravelerFields
  });

  handleInput(countTraveler, {
    enableButton: addTravelerBtn
  });

  if (objFormTraveler.length) {
    calculatorTravelBlock.querySelector('._js-main-foreign-list').innerHTML = '';
    objFormTraveler.forEach((item, idx) => {
      addListTraveler(idx, item.count);
    });

    activeBtnNext();
  }

  addTravelerBtn.addEventListener('click', function (event) {
    event.preventDefault();

    const objSingle = getTravelerObjectFromFields();
    clearTemporaryTraveler();

    objFormTraveler.push(objSingle);

    titleTraveler.innerHTML = `${titleTravels} №${objFormTraveler.length + 1}`;

    addListTraveler(objFormTraveler.length - 1, objSingle.count);
    clearForm();
    activeBtnNext();
    updateTemporaryTraveler();
    updateTravelTotalSumBlock();

    const element = calculatorTravelBlock.querySelector('._js-main-foreign-wrapper-scroll');
    scrollToNode(element, -20);


    localStorage.setItem('calculator-internal-travel', JSON.stringify(objFormTraveler));
  });

  function addListTraveler(idx, end) {
    const container = calculatorTravelBlock.querySelector('._js-main-foreign-list');
    const ending = declension(end, ['ый', 'ых', 'ых']);
    container.innerHTML += innerHTMLList(idx, ending);
  }

  function innerHTMLList(idx, ending) {
    return `<div class="ins-calculator-insured-item _js-main-foreign-list-item" data-count="${idx + 1}">
      <div class="ins-calculator-insured-item__number">${idx + 1}</div>
      <div class="ins-calculator-insured-item__info">${objFormTraveler[idx].age}, ${objFormTraveler[idx].count} застрахованн${ending}${objFormTraveler[idx].additionally ? ',' : ''} ${objFormTraveler[idx].additionally}</div>
      <svg class="ins-calculator-insured-item__edit icon _js-main-foreign-list-edit" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.52171 20.0033H3.99683V15.4785C3.99683 15.0146 4.18099 14.5698 4.50904 14.2419L15.2415 3.50947C15.5694 3.18098 16.0144 2.99638 16.4785 2.99638C16.9426 2.99638 17.3877 3.18098 17.7155 3.50947L20.4907 6.28462C20.8192 6.61248 21.0038 7.05753 21.0038 7.52164C21.0038 7.98575 20.8192 8.4308 20.4907 8.75865L9.75823 19.4911C9.4301 19.8188 8.98543 20.003 8.52171 20.0033Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.0005 5.99751L18.0026 10.9996" stroke="#595F73" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="ins-calculator-insured-item__remove icon _js-main-foreign-list-remove">
          <path d="M5.28003 5.28L18.72 18.72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.28003 18.72L18.72 5.28" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>`
  }

  function clearForm() {
    formRadios.forEach((item, index) => {
      item.checked = index === 0;
    });

    countTraveler.value = 1;
    calculatorTravelBlock.querySelector('._js-select-additional-param').setValue([]);
  }

  let globalCount = null;

  document.addEventListener('click', function(event) {
    const target = event.target;

    if (target.closest('._js-calculator-internal-travel') && (target.classList.contains('_js-main-foreign-list-edit') || target.closest('._js-main-foreign-list-edit'))) {
      const edit = event.target;
      const dataCount = edit.closest('._js-main-foreign-list-item').getAttribute('data-count');
      const btnEdit = edit.closest('._js-main-foreign-list-item').querySelector('._js-main-foreign-list-edit');
      const itemSingle = objFormTraveler[dataCount - 1];
      objFormTraveler[dataCount - 1].isBlocked = true;
      localStorage.setItem('calculator-insured', JSON.stringify(objFormTraveler));

      edit.closest('._js-main-foreign-list').querySelectorAll('._js-main-foreign-list-edit').forEach(item => {
        item.classList.remove('_disabled');
      })
      btnEdit.classList.add('_disabled');

      globalCount = dataCount - 1;

      titleTraveler.innerHTML = `${titleTravels} №${dataCount}`;

      addTravelerBtn.classList.add('_hide');
      saveChangeTravelerBtn.classList.remove('_hide');

      formRadios.forEach(item => {
        item.checked = itemSingle.age === item.value;
      });
      countTraveler.value = itemSingle.count;
      document.querySelector('._js-select-additional-param').setValue(itemSingle.additionally);
    }

    if (target.closest('._js-calculator-internal-travel') && (target.classList.contains('_js-main-foreign-list-remove') || target.closest('._js-main-foreign-list-remove'))) {
      const remove = event.target;
      const dataCount = remove.closest('._js-main-foreign-list-item').getAttribute('data-count');

      objFormTraveler.splice((dataCount - 1), 1);
      remove.closest('._js-main-foreign-list-item').remove();
      titleTraveler.innerHTML = `${titleTravels} №${objFormTraveler.length + 1}`;

      activeBtnNext();
      updateTravelTotalSumBlock();

      localStorage.setItem('calculator-internal-travel', JSON.stringify(objFormTraveler));
    }


    if (target.closest('._js-calculator__step-content--first')) {
      activeBtnNext();
      updateTravelTotalSumBlock();
    }
  });

  document.querySelector('#select-additional-param').addEventListener('change', function() {
    handleTemporaryTravelerFields();
  });

  formRadios.forEach(item => {
    item.addEventListener('change', function() {
      handleTemporaryTravelerFields();
    });
  })

  saveChangeTravelerBtn.addEventListener('click', function (event) {
    event.preventDefault();

    clearTemporaryTraveler();

    if (globalCount || globalCount === 0) {
      const additionally = document.querySelector('._js-select-additional-param').value;
      let check = null;
      let ageCoeff = 1;
      let additionallyCoeff = 1;
      let additionallyText = '';

      formRadios.forEach(item => {
        if (item.checked) {
          check = item.value;
          ageCoeff = item.getAttribute('data-coefficient') ?? 1;
        }
      });

      if (additionally) {
        if (additionally.includes(":")) {
          let additionallyParts = additionally.split(":");
          additionallyCoeff = additionallyParts[0] ?? 1;
          additionallyText = additionallyParts[1];
        } else {
          additionallyText = additionally;
        }
      } else {
        additionallyText = '';
      }

      objFormTraveler[globalCount] = {
        age: check,
        ageCoeff: ageCoeff,
        count: countTraveler.value,
        additionally: additionallyText,
        additionallyCoeff: additionallyCoeff
      }

      const edits = document.querySelectorAll('._js-main-foreign-list-edit');
      edits.forEach(item => item.classList.remove('_disabled'));

      render();
      activeBtnNext();
      updateTemporaryTraveler();
      updateTravelTotalSumBlock();

      titleTraveler.innerHTML = `${titleTravels} №${objFormTraveler.length + 1}`;

      localStorage.setItem('calculator-internal-travel', JSON.stringify(objFormTraveler));
    }
  });

  function render() {
    const container = calculatorTravelBlock.querySelector('._js-main-foreign-list');
    container.innerHTML = '';

    objFormTraveler.forEach((el,idx) => {
      addListTraveler(idx, el.count);
    });

    addTravelerBtn.classList.remove('_hide');
    saveChangeTravelerBtn.classList.add('_hide');

    clearForm();
  }


  nextStep.addEventListener('click', function (event) {
    event.preventDefault();

    const rootStyles = getComputedStyle(document.documentElement);
    const mainWidth = rootStyles.getPropertyValue('--lg-minus');

    const elementTitle = calculatorTravelBlock.querySelector('._js-calculator__title');
    if (elementTitle) {
      scrollToNode(elementTitle, -20);
    }

    if (window.innerWidth < mainWidth) {
      
      cloneNodeToBlock(
          '._js-calculator-internal-travel ._js-calculator__block-warning-message',
          '._js-calculator-internal-travel ._js-calculator__button-back-block',
          'beforeBegin',
          '_js-main-warning-clone'
      )
    } else {
      let clonedWarning = document.querySelector('._js-calculator-internal-travel ._js-main-warning-clone');
      if (clonedWarning) {
        clonedWarning.remove();
      }
    }

    const stepOne = calculatorTravelBlock.querySelector('._js-calculator__step-content--first');
    const topStepTwo = calculatorTravelBlock.querySelector('._js-calculator__top-steps--second');
    const stepTwo = calculatorTravelBlock.querySelector('._js-main-foreign-step-two');

    const information = calculatorTravelBlock.querySelector('._js-calculator__block-info');
    const insurance = calculatorTravelBlock.querySelector('._js-select-insurance-sum').value;

    globalForeign['insurance'] = formatStringFromSelect(insurance);
    globalForeign['startDate'] = startDate;
    globalForeign['endDate'] = endDate;
    globalForeign['foreign'] = objFormTraveler;


    topStepTwo.classList.add('_active');
    stepOne.classList.add('_disabled');
    stepTwo.classList.remove('_disabled');

    let countOfTravelers = 0;
    let counters = globalForeign['foreign'].map((obj, idx) => {
      countOfTravelers = idx + 1;
      return getSingleTravelersBlockHtml(obj, countOfTravelers);
    }).join('\n');
    if (objFormTravelerTemporary) {
      countOfTravelers += 1;
      counters += getSingleTravelersBlockHtml(objFormTravelerTemporary, countOfTravelers);
    }

    information.innerHTML = innerHTMLInformation(counters);
  });

  function innerHTMLInformation(counters) {
    return `
      <div class="ins-calculator-result__includes-title">Период:</div>
      <div class="ins-calculator-result__includes-text">${globalForeign['startDate']} — ${globalForeign['endDate']}</div>
      <div class="ins-calculator-result__includes-title">Страховая сумма:</div>
      <div class="ins-calculator-result__includes-text">${globalForeign['insurance']} ₽</div>
      <div class="ins-calculator-result__includes-title">Количество путешественников:</div>
      <div class="ins-calculator-result__includes-text">${counters}</div>
    `;
  }

  backStep.addEventListener('click', function (event) {
    event.preventDefault();

    const information = calculatorTravelBlock.querySelector('._js-calculator__block-info');
    information.innerHTML = innerHTMLDefault();

    const stepOne = calculatorTravelBlock.querySelector('._js-calculator__step-content--first');
    const topStepTwo = calculatorTravelBlock.querySelector('._js-calculator__top-steps--second');
    const stepTwo = calculatorTravelBlock.querySelector('._js-main-foreign-step-two');

    topStepTwo.classList.remove('_active');
    stepOne.classList.remove('_disabled');
    stepTwo.classList.add('_disabled');

    let clonedWarning = document.querySelector('._js-calculator-internal-travel ._js-main-warning-clone');
    if (clonedWarning) {
      clonedWarning.remove();
    }
    const elementTitle = calculatorTravelBlock.querySelector('._js-calculator__title');
    if (elementTitle) {
      scrollToNode(elementTitle, -20);
    }
  });

  function innerHTMLDefault() {
    return `<div class="ins-calculator-result__includes-title">В страховку включено:</div>
      <div class="ins-calculator-result__includes-text">Амбулаторное лечение, неотложное посещение врача, стоматология, расходы на лекарства по рецепту</div>`;
  }

  function getSingleTravelersBlockHtml(obj, counter) {
    return `<div class="ins-calculator-result__includes-list">
            <span>${counter}.</span>
            ${obj.age}, ${obj.count} застрахованн${declension(obj.count, ['ый', 'ых', 'ых'])}, ${obj.additionally ? `${obj.additionally}` : 'спортивных рисков — нет'}
            </div>`;
  }

  function updateTravelTotalSumBlock() {
    let calculatedSum = calculateTravelSum();
    if (calculatedSum > 0) {
      calculatedSum = calculatedSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      let priceContainer = totalBlock.querySelector('span');
      priceContainer.innerText = calculatedSum + ' ₽';
      totalBlock.classList.add('_active');
    } else {
      totalBlock.classList.remove('_active');
    }
  }

  function calculateTravelSum() {
    if (!startDate || !endDate) {
      return 0;
    }
    let days = differenceInDays(startDate, endDate);
    let insuranceSum = calculatorTravelBlock.querySelector('._js-select-insurance-sum input[name="insurance-sum"]')?.value;
    if (!insuranceSum) {
      return 0;
    }
    let territoryCoeff = calculatorTravelBlock.getAttribute('data-country-coeff');
    let insuranceParts = insuranceSum.split(":");
    let insuranceCoeff =  parseFloat(insuranceParts[0]);
    let insuranceValue =  parseFloat(insuranceParts[1]);

    if (!days
        || !insuranceCoeff
        || !insuranceValue
    ) {
      return 0;
    }
    if (!territoryCoeff) {
      territoryCoeff = 1;
    }
    if (objFormTraveler.length || Object.keys(objFormTravelerTemporary).length !== 0) {
      let sumMultiplier = days *
          parseFloat(territoryCoeff) *
          (insuranceCoeff / 100) *
          insuranceValue;
      let sumArray = [];
      objFormTraveler.forEach(travelersItem => {
        if (travelersItem.ageCoeff && travelersItem.count && travelersItem.additionallyCoeff && !travelersItem.isBlocked) {
          let itemSum = sumMultiplier *
              parseFloat(travelersItem.ageCoeff) *
              parseFloat(travelersItem.count) *
              parseFloat(travelersItem.additionallyCoeff);
          sumArray.push(itemSum)
        }
      });

      if (Object.keys(objFormTravelerTemporary).length !== 0) {
        let sumFromTempItem = sumMultiplier *
            parseFloat(objFormTravelerTemporary.ageCoeff) *
            parseFloat(objFormTravelerTemporary.count) *
            parseFloat(objFormTravelerTemporary.additionallyCoeff);
        sumArray.push(sumFromTempItem);
      }

      return Math.round(sumArray.reduce((a, b) => a + b, 0));
    } else {
      return 0;
    }
  }

  function handleTemporaryTravelerFields() {
    updateTemporaryTraveler();
    updateTravelTotalSumBlock();
  }

  function updateTemporaryTraveler() {
    objFormTravelerTemporary = getTravelerObjectFromFields();
    localStorage.setItem('calculator-temporary-internal-travel', JSON.stringify(objFormTravelerTemporary));
  }

  function clearTemporaryTraveler(){
    Object.keys(objFormTravelerTemporary).forEach(key => delete objFormTravelerTemporary[key]);
    localStorage.removeItem('calculator-temporary-internal-travel');
  }

  function getTravelerObjectFromFields() {
    const objSingle = {};

    const additionally = calculatorTravelBlock.querySelector('._js-select-additional-param').value;
    objSingle.ageCoeff=1;
    objSingle.additionallyCoeff = 1;

    formRadios.forEach(item => {
      if (item.checked) {
        objSingle.age = item.value;
        objSingle.ageCoeff = item.getAttribute('data-coefficient') ?? 1;
      }
    });

    objSingle.count = countTraveler.value;
    if (additionally) {
      if (additionally.includes(":")) {
        let additionallyParts = additionally.split(":");
        objSingle.additionallyCoeff = additionallyParts[0] ?? 1;
        objSingle.additionally = additionallyParts[1];
      } else {
        objSingle.additionally = additionally;
      }
    } else {
      objSingle.additionally = '';
    }
    return objSingle;
  }
}

window.addEventListener('b24:form:submit', function(e) {
  const secondStepTravel = document.querySelector('._js-form-internal-travel-step-two');
  let formId = secondStepTravel?.getAttribute('data-bitrix-form-id');
  let formAttributeTo = secondStepTravel?.getAttribute('data-bitrix-hidden-field');
  let form = e.detail.object;
  if (formId && formAttributeTo && form.identification.id == formId) {
    let calculatorTravelBlock = document.querySelector('._js-calculator-internal-travel');
    let startDateInsurance = calculatorTravelBlock.querySelector('._js-start-date');
    let endDateInsurance = calculatorTravelBlock.querySelector('._js-end-date');

    let insurance = calculatorTravelBlock.querySelector('._js-select-insurance-sum')?.value;
    let insuredList = JSON.parse(localStorage.getItem('calculator-internal-travel'));
    let insuredTemporary = JSON.parse(localStorage.getItem('calculator-temporary-internal-travel'));
    const totalBlock = calculatorTravelBlock.querySelector('._js-calculator__block-total-sum span');
    let data = new FormData();
    if (startDateInsurance && endDateInsurance) {
      let dateString = 'с ' + startDateInsurance.value + ' до ' + endDateInsurance.value
      data.append('Дата страхования', dateString);
    }

    if (insurance) {
      let insuranceString = formatStringFromSelect(insurance);
      data.append('Страховая сумма', insuranceString + ' ₽');
    }
    if (insuredList || insuredTemporary) {
      let insuredListString = '';
      if (insuredList) {
        insuredListString = insuredList.map((obj, idx) => {
          return `${obj.age}, ${obj.count} застрахованн${declension(obj.count, ['ый', 'ых', 'ых'])}, ${obj.additionally ? `${obj.additionally}` : 'спортивных рисков — нет; '}`;
        })
      }
      if (insuredTemporary) {
        insuredListString += `${insuredTemporary.age}, ${insuredTemporary.count} застрахованн${declension(insuredTemporary.count, ['ый', 'ых', 'ых'])}, ${insuredTemporary.additionally ? `${insuredTemporary.additionally}` : 'спортивных рисков — нет; '}`;
      }
      if (insuredListString) {
        data.append('Застрахованные', insuredListString);
      }
      if (totalBlock) {
        data.append('Предварительный расчет страховой премии ', totalBlock.innerText);
      }
    }

    let dataString = formDataToString(data);
    form.setProperty(formAttributeTo, dataString);
  }
});